import moment from 'moment';
import { Column } from './Column';
import { State } from './State';

export function defaultDropdownFilterConverter(
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  value: any,
  fieldName: string,
  columns: Column[] | undefined,
  state: State
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  if (columns && state) {
    const filteredColumns = columns.filter((c) => c.fieldName === fieldName);
    const column = filteredColumns && filteredColumns.length > 0 ? filteredColumns[0] : undefined;
    if (column && column.dropdownOptions) {
      const filterType = state.filters.filter((f) => f.fieldName === column.fieldName);
      return column.dropdownOptions
        .filter((d) =>
          filterType &&
          filterType.length > 0 &&
          (filterType[0].filterType === 'equals' || filterType[0].filterType === 'notequals')
            ? d.id === value
            : false
        )
        .map((d) => d.id);
    }
  }
  return value;
}

export function toDateTimeString(date: string | Date): string {
  return date ? moment(date).format('DD.MM.YYYY HH:mm') : date;
}

export function toDateString(date: string | Date): string {
  return date ? moment(date).format('DD.MM.YYYY') : date;
}

export function toIntlDateString(date: string | Date): string {
  return date ? moment(date).format('YYYY-MM-DD') : date;
}
